import type { OnDestroy, OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';
import type { ToastAlertContainerComponentInterface } from './toast-alert-container.types';
import { ToastAlertService } from './toast-alert.service';
import { ContainerComponent } from '../container/container.component';

@Component({
  standalone: true,
  selector: 'fl-toast-alert-container',
  imports: [ContainerComponent],
  template: `
    <fl-container [mobilePadding]="true">
      <div class="ToastAlertInner">
        <div
          class="ToastAlertContainer"
          #container
        ></div>
      </div>
    </fl-container>
  `,
  styleUrls: ['./toast-alert-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastAlertContainerComponent
  implements ToastAlertContainerComponentInterface, OnInit, OnDestroy
{
  private element = inject(ElementRef);
  private toastAlertService = inject(ToastAlertService);

  @ViewChild('container', { read: ElementRef })
  container: ElementRef<HTMLDivElement>;

  ngOnInit(): void {
    this.toastAlertService.registerContainer(this);
  }

  isElementVisible(): boolean {
    const { nativeElement } = this.element;

    return nativeElement.offsetWidth > 0 || nativeElement.offsetHeight > 0;
  }

  ngOnDestroy(): void {
    this.toastAlertService.unregisterContainer(this);
  }
}
